import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=5afaf691&scoped=true&"
import script from "./auth.vue?vue&type=script&lang=js&"
export * from "./auth.vue?vue&type=script&lang=js&"
import style0 from "./auth.vue?vue&type=style&index=0&id=5afaf691&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afaf691",
  null
  
)

component.options.__file = "auth.vue"
export default component.exports